<app-loading *ngIf="isLoading"></app-loading>

<router-outlet></router-outlet>
<ng-container *ngIf="toastService.show | async as toast">
  <app-toast [data]="toast"></app-toast>
</ng-container>

<ng-template #modal></ng-template>
